import React from 'react';
import './PrintableForm.css';

const NewClientRegistration: React.FC = () => {
  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="printable-form-container">
      <div className="no-print actions-bar">
        <button onClick={() => window.history.back()} className="back-btn">← Back to Forms</button>
        <button onClick={handlePrint} className="print-btn">🖨️ Print / Save as PDF</button>
      </div>

      <div className="printable-form">
        <div className="form-header">
          <h1>The Pet Nanny of Weston</h1>
          <p className="tagline">Licensed • Bonded • Insured</p>
          <p className="contact">thepetnannyofweston@gmail.com</p>
        </div>

        <h2 className="form-title">New Client Registration Form</h2>

        <div className="form-section">
          <h3>Owner Information</h3>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Full Name:</label>
              <input type="text" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Street Address:</label>
              <input type="text" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-field half-width">
              <label>City:</label>
              <input type="text" />
            </div>
            <div className="form-field quarter-width">
              <label>State:</label>
              <input type="text" />
            </div>
            <div className="form-field quarter-width">
              <label>ZIP Code:</label>
              <input type="text" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-field half-width">
              <label>Primary Phone:</label>
              <input type="tel" />
            </div>
            <div className="form-field half-width">
              <label>Secondary Phone:</label>
              <input type="tel" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Email Address:</label>
              <input type="email" />
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>Emergency Contacts</h3>
          <p className="section-note">Please provide two emergency contacts who can be reached if we cannot reach you.</p>
          
          <div className="subsection">
            <h4>Emergency Contact #1</h4>
            <div className="form-row">
              <div className="form-field half-width">
                <label>Name:</label>
                <input type="text" />
              </div>
              <div className="form-field half-width">
                <label>Relationship:</label>
                <input type="text" />
              </div>
            </div>
            <div className="form-row">
              <div className="form-field half-width">
                <label>Phone Number:</label>
                <input type="tel" />
              </div>
              <div className="form-field half-width">
                <label>Email:</label>
                <input type="email" />
              </div>
            </div>
          </div>

          <div className="subsection">
            <h4>Emergency Contact #2</h4>
            <div className="form-row">
              <div className="form-field half-width">
                <label>Name:</label>
                <input type="text" />
              </div>
              <div className="form-field half-width">
                <label>Relationship:</label>
                <input type="text" />
              </div>
            </div>
            <div className="form-row">
              <div className="form-field half-width">
                <label>Phone Number:</label>
                <input type="tel" />
              </div>
              <div className="form-field half-width">
                <label>Email:</label>
                <input type="email" />
              </div>
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>Veterinarian Information</h3>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Veterinary Clinic Name:</label>
              <input type="text" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-field half-width">
              <label>Phone Number:</label>
              <input type="tel" />
            </div>
            <div className="form-field half-width">
              <label>Emergency Phone:</label>
              <input type="tel" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Address:</label>
              <input type="text" />
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>Additional Information</h3>
          <div className="form-row">
            <div className="form-field full-width">
              <label>How did you hear about The Pet Nanny of Weston?</label>
              <input type="text" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-field half-width">
              <label>Date of First Service:</label>
              <input type="date" />
            </div>
          </div>
        </div>

        <div className="form-section signature-section">
          <h3>Signature</h3>
          <p className="section-note">
            I certify that the information provided above is accurate and complete. I understand that I must provide 
            additional pet-specific forms for each animal in my care.
          </p>
          <div className="form-row">
            <div className="form-field half-width">
              <label>Signature:</label>
              <div className="signature-line"></div>
            </div>
            <div className="form-field half-width">
              <label>Date:</label>
              <input type="date" />
            </div>
          </div>
        </div>

        <div className="form-footer">
          <p>Page 1 of 1</p>
          <p>The Pet Nanny of Weston • thepetnannyofweston@gmail.com</p>
        </div>
      </div>
    </div>
  );
};

export default NewClientRegistration;
